import type React from 'react';

import { USECASE_IN_SEARCH_PARAM } from '@/constant/Constants';
import { explorerAnalytics } from '@/lib/analytics';
import type { CodeSample } from '@/services/postmanCollection/postman_util';
import { cn } from '@components/lib/utils';

export interface PostmanCollectionsProps {
  samples: CodeSample[];
  setCodeSample: (codeSample?: CodeSample) => void;
  value: string;
  setSelectedValue: (value: string) => void;
  clearSelection: () => void;
}

export const SampleUseCase: React.FC<PostmanCollectionsProps> = ({
  value,
  samples,
  setCodeSample,
  setSelectedValue,
  clearSelection,
}) => {
  const handleChange = (value: string) => {
    clearSelection();
    setSelectedValue(value);
    const sampleIndex = samples.findIndex((sample) => sample.desc === value);
    const codeSample = samples[sampleIndex];
    setCodeSample({ ...codeSample });

    explorerAnalytics.codeSampleSelected({
      resource: '',
      endpoint: '',
      sampleDescription: value,
      sampleIndex,
    });

    const params = new URLSearchParams(window.location.search);
    const base64Params = btoa(JSON.stringify(codeSample.params));
    params.set(USECASE_IN_SEARCH_PARAM, base64Params);

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : '');

    window.history.replaceState({}, '', newUrl);
  };

  return (
    <div className="my-3">
      <h3 className="text-[12px] font-medium text-gray-500 mb-2">Use Cases</h3>
      <div className="flex flex-wrap gap-2">
        {samples.map((sample) => (
          <button
            type="button"
            key={sample.desc}
            onClick={() => handleChange(sample.desc)}
            className={cn(
              'px-3 py-1.5 text-sm rounded-full border cursor-pointer transition-colors',
              value === sample.desc
                ? 'bg-shade-teal-500/15 border-shade-teal-500 text-shade-teal-900'
                : 'border-gray-400 hover:bg-gray-50 text-gray-700'
            )}
          >
            {sample.desc}
          </button>
        ))}
      </div>
    </div>
  );
};
